import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

export const GroupedMenuBodyLeft = (props) => {
	const {
		className,
		children
	} = props;

	return (
		<div className={classNames(className, 'ads-grouped-menu-body-left')}>{children}</div>
	);
}

GroupedMenuBodyLeft.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

GroupedMenuBodyLeft.defaultProps = {
	className: '',
};
